import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    productcancelpolicyisLoading : false,
    productcancelpolicy: [],
    totalCurrency: 0,
    numOfPcancels: 1,
    pcancel: 1,
    stats: {},
    monthlyApplications: [],
    productcancelpolicyiscLoading:false,
    productcancelpolicyCstatus:"",
    productcancelpolicyCMesscancel:"",
    productcancelpolicydetails:{},
    productcancelpolicyismloading:false,
    productcancelpolicymstatus:"",
    productcancelpolicymmesscancel:"",
    cancelpolicies: {},
    productcancelpolicydstatus:"",
    productcancelpolicydmesscancel:"",
    error:"",
    
};


const productcancelpolicySlice = createSlice({
    name: "cancelpolicyList",
    initialState,
    reducers:{
        getProductCancelPolicyPending: (state) => {
            state.productcancelpolicyisLoading = true;
        },
        getProductCancelPolicySuccess: (state, { payload }) => {
            state.productcancelpolicyisLoading = false;
            state.productcancelpolicy = payload;
            state.productcancelpolicydetails = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getProductCancelPolicyFail: (state, { payload }) => {
            state.productcancelpolicyisLoading = false;
            state.error = payload;
        },
        createProductCancelPolicyPending:(state,action) => {
            state.productcancelpolicyiscLoading=true;
        },
        createProductCancelPolicySuccess:(state,{payload}) => {
            state.productcancelpolicyiscLoading=false;
            state.productcancelpolicyCstatus="success";
            state.productcancelpolicyCMesscancel=payload;
        },
        createProductCancelPolicyFail:(state,{payload}) => {
            state.productcancelpolicyiscLoading=false;
            state.productcancelpolicyCstatus="fail";
            //console.log('slice '+payload);
            state.productcancelpolicyCMesscancel=payload;
        },
        getSProductCancelPolicyPending: (state) => {
            state.productcancelpolicyisLoading = true;
        },
        getSProductCancelPolicySuccess: (state, { payload }) => {
            state.productcancelpolicyisLoading = false;
            state.cancelpolicies=payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSProductCancelPolicyFail: (state, { payload }) => {
            state.productcancelpolicyisLoading = false;
            state.error = payload;
        },
        modifyProductCancelPolicyPending:(state,action) => {
            state.productcancelpolicyismloading=true;
            state.productcancelpolicymstatus="";
        },
        modifyProductCancelPolicySuccess:(state,{payload}) => {
            state.productcancelpolicyismloading=false;
            state.productcancelpolicymstatus="success";
           
            state.productcancelpolicymmesscancel="ProductCancelPolicy Successfully Updated";
        },
        modifyProductCancelPolicyFail:(state,{payload}) => {
            state.productcancelpolicyismloading=false;
            state.productcancelpolicymstatus="fail";
           // console.log('slice '+payload);
            state.productcancelpolicymmesscancel=payload;
        },
        deleteProductCancelPolicyPending:(state,action) => {
            state.productcancelpolicyisloading=true;
            state.productcancelpolicydstatus="";
        },
        deleteProductCancelPolicySuccess:(state,{payload}) => {
            state.productcancelpolicyisLoading=false;
            state.productcancelpolicydstatus="success";
            state.productcancelpolicydmesscancel="ProductCancelPolicy Successfully Deleted";
        },
        deleteProductCancelPolicyFail:(state,{payload}) => {
            state.productcancelpolicyisLoading=false;
            state.productcancelpolicydstatus="fail";
           // console.log('slice '+payload);
            state.productcancelpolicydmesscancel=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = productcancelpolicySlice;

export const { getProductCancelPolicyPending, getProductCancelPolicySuccess, getProductCancelPolicyFail,getSProductCancelPolicyPending, getSProductCancelPolicySuccess, getSProductCancelPolicyFail, 
    createProductCancelPolicyPending, createProductCancelPolicySuccess, createProductCancelPolicyFail,
    modifyProductCancelPolicyPending,modifyProductCancelPolicySuccess,modifyProductCancelPolicyFail,
    deleteProductCancelPolicyPending,deleteProductCancelPolicySuccess,deleteProductCancelPolicyFail  } = actions;

export default reducer;
